import { render, staticRenderFns } from "./active-promotion.vue?vue&type=template&id=f8dc33b8"
import script from "./active-promotion.vue?vue&type=script&lang=js"
export * from "./active-promotion.vue?vue&type=script&lang=js"
import style0 from "./active-promotion.vue?vue&type=style&index=0&id=f8dc33b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports